import { AppstoreAddOutlined } from '@ant-design/icons';
import React, { Fragment, useContext } from 'react';

import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useRowState } from '../../../../../hooks/useRowState';
import { CollapsibleTableRow } from '../../../../Table/CollapsibleTableRow/CollapsibleTableRow';
import { SectionRow } from '../../../../Table/SectionRow/SectionRow';

import { RoomPriceDiscountRow } from './RoomPriceDiscountRow';

const RoomPackPricesRowComponent: React.FC<{
  roomId: number;
  roomName: string;
}> = ({ roomId, roomName }) => {
  const { getPublishedAndUnpublishedPacksContainingRoom } =
    useContext(ModernHotelContext);

  const { inventoryPacks } = useRowState(InventoryTabItemName.Packs);

  if (!inventoryPacks) {
    return null;
  }

  const publishedPacks = getPublishedAndUnpublishedPacksContainingRoom(
    roomId
  ).filter((pack) => !pack.isDaytime);

  return (
    <CollapsibleTableRow
      panelKey={`pack-prices-${roomId}`}
      label="Total package prices"
    >
      {publishedPacks.length === 0 ? (
        <EmptyState
          title="No published packages"
          description="Contact your AM to associate a package to this room."
          icon={<AppstoreAddOutlined />}
        />
      ) : (
        publishedPacks.map((pack) => (
          <Fragment key={`section-${roomId}-${pack.id}`}>
            <SectionRow labels={[roomName, pack.nameForHotel]} />
            <RoomPriceDiscountRow packId={pack.id} roomId={roomId} />
          </Fragment>
        ))
      )}
    </CollapsibleTableRow>
  );
};

export const RoomPackPricesRow = React.memo(RoomPackPricesRowComponent);
